// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

body {
    margin: 0;
    font-family: "M PLUS 1p", "Rubik", sans-serif;
    background: #f2f4f7;
    color: #0f172a;
}

a {
    text-decoration: none;
}

.page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #f2f4f7;
}

.shell {
    width: 100%;
    max-width: 1400px;
    background: #ffffff;
    border-radius: 32px;
    overflow: hidden;
    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.15);
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 40px;
}

.brand {
    display: flex;
    align-items: center;
    gap: 12px;
}

.brand-mark {
    width: 48px;
    height: 48px;
    padding: 8px;
    border-radius: 18px;
    background: #444444;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.brand-mark img {
    width: 32px;
    height: 32px;
    display: block;
}

.brand-title {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #64748b;
    margin: 0;
}

.brand-subtitle {
    font-size: 12px;
    color: #94a3b8;
    margin: 2px 0 0;
}

.nav {
    display: flex;
    align-items: center;
    gap: 32px;
}

.nav a {
    font-size: 14px;
    color: #64748b;
    transition: color 0.2s ease;
}

.nav a:hover {
    color: #111827;
}

[dir="rtl"] .hero { direction: rtl; }
[dir="rtl"] .hero-copy { text-align: right; }
[dir="rtl"] .hero-visual { transform: scaleX(-1); }
[dir="rtl"] .nav { direction: rtl; }
[dir="rtl"] .eyebrow { flex-direction: row-reverse; }
[dir="rtl"] .modal-close {
    right: auto;
    left: 12px;
}

.button {
    appearance: none;
    border: none;
    cursor: pointer;
    font: inherit;
    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.button:active {
    transform: translateY(1px);
}

.button-contact {
    padding: 11px 20px;
    border-radius: 999px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    color: #334155;
}

.button-contact:hover {
    opacity: 0.96;
}

.hero {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 700px;
}

.hero-copy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 56px;
}

.eyebrow {
    margin: 0 0 16px;
    font-size: 12px;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #94a3b8;
}

.headline {
    margin: 0;
    font-size: 64px;
    line-height: 1.02;
    font-weight: 700;
    letter-spacing: -0.04em;
    color: #0f172a;
    max-width: 520px;
}

.description {
    margin: 24px 0 0;
    font-size: 20px;
    line-height: 1.7;
    color: #64748b;
    max-width: 520px;
}

.actions {
    display: flex;
    gap: 16px;
    margin-top: 32px;
}

.button-primary {
    padding: 15px 24px;
    border-radius: 14px;
    color: #ffffff;
    background: linear-gradient(110deg, #c611e1 0%, #13eccb 100%);
    box-shadow: 0 16px 34px rgba(59, 130, 246, 0.22);
}

.button-primary:hover {
    opacity: 0.96;
    transform: translateY(-1px);
}

.button-secondary {
    padding: 15px 24px;
    border-radius: 14px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    color: #334155;
}

.button-secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

.hero-visual {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 40px 32px 16px;
}

.hero-visual img {
    width: 100%;
    max-width: 640px;
    height: auto;
    display: block;
    object-fit: contain;
}

@media (max-width: 1100px) {
    .headline {
        font-size: 52px;
    }

    .hero-copy {
        padding: 48px;
    }
}
.lang {
    position: relative;
}

.lang-btn {
    border: none;
    background: #f1f5f9;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
}

.lang-menu {
    position: absolute;
    top: 40px;
    right: 0;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    display: none;
    flex-direction: column;
    min-width: 100px;
    overflow: hidden;
}

.lang.open .lang-menu {
    display: flex;
}

.lang-menu button {
    background: none;
    border: none;
    padding: 10px;
    text-align: left;
    cursor: pointer;
}

.lang-menu button:hover {
    background: #f8fafc;
}

.lang button {
    border: none;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: pointer;
}

@media (max-width: 900px) {
    .header {
        padding: 20px 24px;
    }

    .nav {
        display: none;
    }

    .hero {
        grid-template-columns: 1fr;
    }

    .hero-copy {
        padding: 32px 24px 8px;
    }

    .hero-visual {
        padding: 16px 24px 32px;
    }

    .headline {
        font-size: 44px;
        max-width: none;
    }

    .description {
        font-size: 18px;
        max-width: none;
    }
}

@media (max-width: 560px) {
    .page {
        padding: 12px;
    }

    .shell {
        border-radius: 24px;
    }

    .brand-title {
        letter-spacing: 0.12em;
    }

    .headline {
        font-size: 36px;
    }

    .actions {
        flex-direction: column;
        align-items: stretch;
    }

    .button-primary,
    .button-secondary,
    .button-contact {
        width: 100%;
    }
}

.modal-overlay {
    position: fixed;
    inset: 0;
    padding: 16px;
    background: rgba(0, 0, 0, 0.4);

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    animation: overlayFade 0.25s ease;
}

.modal {
    width: 100%;
    max-width: 420px;
    background: white;
    border-radius: 16px;
    padding: 24px;

    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2);

    animation: modalIn 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

/* Overlay */
@keyframes overlayFade {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* Modal */
@keyframes modalIn {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal input,
.modal textarea {
    width: 100%;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    font: inherit;
    background: #f8fafc;
    transition: all 0.2s ease;
}

/* Placeholder */
.modal input::placeholder,
.modal textarea::placeholder {
    color: #94a3b8;
}

/* Hover */
.modal input:hover,
.modal textarea:hover {
    border-color: #cbd5e1;
    background: #ffffff;
}

/* Focus (important) */
.modal input:focus,
.modal textarea:focus {
    outline: none;
    border-color: #2563eb;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

/* Textarea tweak */
.modal textarea {
    resize: none;
}

.modal input:invalid,
.modal textarea:invalid {
    border-color: #ef4444;
}

.modal input:focus:invalid,
.modal textarea:focus:invalid {
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
}

.modal input:invalid:not(:focus):not(:placeholder-shown),
.modal textarea:invalid:not(:focus):not(:placeholder-shown) {
    border-color: #ef4444;
}

@keyframes pop {
    0% { transform: scale(0.6); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/Main.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,6CAA6C;IAC7C,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,oBAAoB,cAAc,EAAE;AACpC,yBAAyB,iBAAiB,EAAE;AAC5C,2BAA2B,qBAAqB,EAAE;AAClD,mBAAmB,cAAc,EAAE;AACnC,uBAAuB,2BAA2B,EAAE;AACpD;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,4HAA4H;AAChI;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,6DAA6D;IAC7D,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;;;QAGI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,8BAA8B;;IAE9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;;IAEb,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;;IAEb,0CAA0C;;IAE1C,sDAAsD;AAC1D;;AAEA,YAAY;AACZ;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA,UAAU;AACV;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;;IAEI,cAAc;AAClB;;AAEA,UAAU;AACV;;IAEI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;;IAEI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA,mBAAmB;AACnB;IACI,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,KAAK,qBAAqB,EAAE,UAAU,EAAE;IACxC,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC5C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap');\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    margin: 0;\n    font-family: \"M PLUS 1p\", \"Rubik\", sans-serif;\n    background: #f2f4f7;\n    color: #0f172a;\n}\n\na {\n    text-decoration: none;\n}\n\n.page {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n    background: #f2f4f7;\n}\n\n.shell {\n    width: 100%;\n    max-width: 1400px;\n    background: #ffffff;\n    border-radius: 32px;\n    overflow: hidden;\n    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.15);\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 24px 40px;\n}\n\n.brand {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.brand-mark {\n    width: 48px;\n    height: 48px;\n    padding: 8px;\n    border-radius: 18px;\n    background: #444444;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.brand-mark img {\n    width: 32px;\n    height: 32px;\n    display: block;\n}\n\n.brand-title {\n    font-size: 14px;\n    font-weight: 700;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    color: #64748b;\n    margin: 0;\n}\n\n.brand-subtitle {\n    font-size: 12px;\n    color: #94a3b8;\n    margin: 2px 0 0;\n}\n\n.nav {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n}\n\n.nav a {\n    font-size: 14px;\n    color: #64748b;\n    transition: color 0.2s ease;\n}\n\n.nav a:hover {\n    color: #111827;\n}\n\n[dir=\"rtl\"] .hero { direction: rtl; }\n[dir=\"rtl\"] .hero-copy { text-align: right; }\n[dir=\"rtl\"] .hero-visual { transform: scaleX(-1); }\n[dir=\"rtl\"] .nav { direction: rtl; }\n[dir=\"rtl\"] .eyebrow { flex-direction: row-reverse; }\n[dir=\"rtl\"] .modal-close {\n    right: auto;\n    left: 12px;\n}\n\n.button {\n    appearance: none;\n    border: none;\n    cursor: pointer;\n    font: inherit;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.button:active {\n    transform: translateY(1px);\n}\n\n.button-contact {\n    padding: 11px 20px;\n    border-radius: 999px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    color: #334155;\n}\n\n.button-contact:hover {\n    opacity: 0.96;\n}\n\n.hero {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    min-height: 700px;\n}\n\n.hero-copy {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 56px;\n}\n\n.eyebrow {\n    margin: 0 0 16px;\n    font-size: 12px;\n    letter-spacing: 0.18em;\n    text-transform: uppercase;\n    color: #94a3b8;\n}\n\n.headline {\n    margin: 0;\n    font-size: 64px;\n    line-height: 1.02;\n    font-weight: 700;\n    letter-spacing: -0.04em;\n    color: #0f172a;\n    max-width: 520px;\n}\n\n.description {\n    margin: 24px 0 0;\n    font-size: 20px;\n    line-height: 1.7;\n    color: #64748b;\n    max-width: 520px;\n}\n\n.actions {\n    display: flex;\n    gap: 16px;\n    margin-top: 32px;\n}\n\n.button-primary {\n    padding: 15px 24px;\n    border-radius: 14px;\n    color: #ffffff;\n    background: linear-gradient(110deg, #c611e1 0%, #13eccb 100%);\n    box-shadow: 0 16px 34px rgba(59, 130, 246, 0.22);\n}\n\n.button-primary:hover {\n    opacity: 0.96;\n    transform: translateY(-1px);\n}\n\n.button-secondary {\n    padding: 15px 24px;\n    border-radius: 14px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    color: #334155;\n}\n\n.button-secondary:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n}\n\n.hero-visual {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 32px 40px 32px 16px;\n}\n\n.hero-visual img {\n    width: 100%;\n    max-width: 640px;\n    height: auto;\n    display: block;\n    object-fit: contain;\n}\n\n@media (max-width: 1100px) {\n    .headline {\n        font-size: 52px;\n    }\n\n    .hero-copy {\n        padding: 48px;\n    }\n}\n.lang {\n    position: relative;\n}\n\n.lang-btn {\n    border: none;\n    background: #f1f5f9;\n    padding: 8px 12px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.lang-menu {\n    position: absolute;\n    top: 40px;\n    right: 0;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    display: none;\n    flex-direction: column;\n    min-width: 100px;\n    overflow: hidden;\n}\n\n.lang.open .lang-menu {\n    display: flex;\n}\n\n.lang-menu button {\n    background: none;\n    border: none;\n    padding: 10px;\n    text-align: left;\n    cursor: pointer;\n}\n\n.lang-menu button:hover {\n    background: #f8fafc;\n}\n\n.lang button {\n    border: none;\n    padding: 6px 10px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n@media (max-width: 900px) {\n    .header {\n        padding: 20px 24px;\n    }\n\n    .nav {\n        display: none;\n    }\n\n    .hero {\n        grid-template-columns: 1fr;\n    }\n\n    .hero-copy {\n        padding: 32px 24px 8px;\n    }\n\n    .hero-visual {\n        padding: 16px 24px 32px;\n    }\n\n    .headline {\n        font-size: 44px;\n        max-width: none;\n    }\n\n    .description {\n        font-size: 18px;\n        max-width: none;\n    }\n}\n\n@media (max-width: 560px) {\n    .page {\n        padding: 12px;\n    }\n\n    .shell {\n        border-radius: 24px;\n    }\n\n    .brand-title {\n        letter-spacing: 0.12em;\n    }\n\n    .headline {\n        font-size: 36px;\n    }\n\n    .actions {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .button-primary,\n    .button-secondary,\n    .button-contact {\n        width: 100%;\n    }\n}\n\n.modal-overlay {\n    position: fixed;\n    inset: 0;\n    padding: 16px;\n    background: rgba(0, 0, 0, 0.4);\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n\n    animation: overlayFade 0.25s ease;\n}\n\n.modal {\n    width: 100%;\n    max-width: 420px;\n    background: white;\n    border-radius: 16px;\n    padding: 24px;\n\n    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2);\n\n    animation: modalIn 0.3s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n/* Overlay */\n@keyframes overlayFade {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n/* Modal */\n@keyframes modalIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px) scale(0.96);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n.modal input,\n.modal textarea {\n    width: 100%;\n    padding: 14px 16px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    font: inherit;\n    background: #f8fafc;\n    transition: all 0.2s ease;\n}\n\n/* Placeholder */\n.modal input::placeholder,\n.modal textarea::placeholder {\n    color: #94a3b8;\n}\n\n/* Hover */\n.modal input:hover,\n.modal textarea:hover {\n    border-color: #cbd5e1;\n    background: #ffffff;\n}\n\n/* Focus (important) */\n.modal input:focus,\n.modal textarea:focus {\n    outline: none;\n    border-color: #2563eb;\n    background: #ffffff;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n/* Textarea tweak */\n.modal textarea {\n    resize: none;\n}\n\n.modal input:invalid,\n.modal textarea:invalid {\n    border-color: #ef4444;\n}\n\n.modal input:focus:invalid,\n.modal textarea:focus:invalid {\n    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);\n}\n\n.modal input:invalid:not(:focus):not(:placeholder-shown),\n.modal textarea:invalid:not(:focus):not(:placeholder-shown) {\n    border-color: #ef4444;\n}\n\n@keyframes pop {\n    0% { transform: scale(0.6); opacity: 0; }\n    100% { transform: scale(1); opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
